<script>
import Layout from '@layouts/auth'
// import Main from '@layouts/main'
import {
  BIcon,
  BIconExclamationCircleFill,
  BIconCheckCircleFill,
  BIconGearFill,
  BIconArrowLeftShort,
  BIconQuestionCircle,
} from 'bootstrap-vue'
// import SideBar from '@components/side-bar'
// import CajasPos from '@components/cajasPOS'
// import PageHeader from '@components/page-header'

// Vuex
import { mapGetters } from 'vuex'
import { habeasMethods, captacionMethods } from '@state/helpers'

// Cajas POS
// import { authComputed } from '@state/helpers'

import Multiselect from 'vue-multiselect'

export default {
  page: {
    title: 'Habeas data',
  },
  components: {
    Layout,
    BIcon,
    BIconExclamationCircleFill,
    BIconCheckCircleFill,
    BIconGearFill,
    BIconArrowLeftShort,
    BIconQuestionCircle,
    // CajasPos,
    Multiselect,
  },
  data() {
    return {
      data_form: {
        tipo_docto: 'C.C',
        nit: '',
        celular: '',
        cashRegister: null,
        casherRegister: null,
        store: null,
        storeCity: null,
        storeDepartment: null,
      },
      rejection_form: {
        tipo_docto: 'C.C',
        nit: '',
        selectedRejection: null,
        cashRegister: null,
        casherRegister: null,
        store: null,
        storeCity: null,
        storeDepartment: null,
      },

      onlyNit: true,
      formType: {
        id: null,
        form: 'Habeas Data - Captación Pos',
      },
      dismissSecs: 3.5,
      dismissCountDown: 0,
      options: ['C.C', 'C.E', 'NIT'],
      message_nit: '',
      message_cel: '',
      correct_nit: '',
      correct_cel: '',
      typeAlert: 'warning', // bootstrap alert type to show
      textAlert: '', // text to show in Alert
      cajasIsOpen: false,
      alertForm: false,
      modalShow: false,
      rejectionTitle: 'Motivo rechazo Habeas Data',
      selectedRejection: null,
      rejectHabeas: false,

      //   { id: 3, name: 'Habeas Data - Captación Pos' },
      // Cajas POS
      // formOptions: [
      //   { id: 1, name: 'Habeas Data' },
      //   { id: 2, name: 'Captación Pos' },
      //   { id: 3, name: 'Habeas Data - Captación Pos' },
      // ],
      // stores: [],
      cash_registers: [],
      casher_registers: [],
      // store: null,
      // cashRegister: null,
      formOption: null,
    }
  },
  mounted() {
    // Getting stores and Cash Registers
    // this.getCashRegisters()
    console.log(this.store)
    this.data_form.store = this.store.store_code || null
    this.data_form.storeCity = this.store.city || null
    this.data_form.storeDepartment = this.store.department || null
    this.data_form.cashRegister = this.cashRegister.id || null
    this.data_form.casherRegister = this.casherRegister.codcaj || null
    // this.alertForm = Boolean(this.data_form.store && this.data_form.cashRegister)
    // console.log('Initialice')
    this.rejection_form.store = this.store.store_code || null
    this.rejection_form.storeCity = this.store.city || null
    this.rejection_form.storeDepartment = this.store.department || null
    this.rejection_form.cashRegister = this.cashRegister.id || null
    this.rejection_form.casherRegister = this.casherRegister.codcaj || null
  },

  watch: {
    store(val) {
      this.data_form.store = val.store_name
      this.data_form.storeCity = val.city
      this.data_form.storeDepartment = val.department
      // this.alertForm = Boolean(this.data_form.store && this.data_form.cashRegister)
      this.rejection_form.store = val.store_name
      this.rejection_form.storeCity = val.city
      this.rejection_form.storeDepartment = val.department
    },
    cashRegister(val) {
      this.data_form.cashRegister = val ? val.id : null
      this.rejection_form.cashRegister = val ? val.id : null
      // this.alertForm = Boolean(this.data_form.store && this.data_form.cashRegister)
    },
    casherRegister(val) {
      this.data_form.casherRegister = val ? val.codcaj : null
      this.rejection_form.casherRegister = val ? val.codcaj : null
      // this.alertForm = Boolean(this.data_form.store && this.data_form.cashRegister)
    },
  },
  computed: {
    ...mapGetters({
      stores: 'captacionPos/stores',
      store: 'captacionPos/store',
      cashRegister: 'captacionPos/cashRegister',
      casherRegister: 'captacionPos/casherRegister',
    }),

    // alertForm: function(){
    //   return
    // }
  },

  methods: {
    ...habeasMethods,

    enviarForm() {
      this.formType.id = 3
      this.data_form.nit.trim()
      this.correct_nit = this.validateDocument(this.data_form.nit)
      if (!this.correct_nit) {
        return null
      }

      if (this.onlyNit) {
        this.data_form.celular = ''
      } else {
        this.data_form.celular.trim()
        if (this.data_form.celular !== '') {
          this.correct_cel = this.validateCellphone(this.data_form.celular)
          if (!this.correct_cel) {
            return null
          }
        }
      }
      // Copy nit to clipboard
      navigator.clipboard.writeText(this.data_form.nit)
      if (!this.rejectHabeas == true) {
        return this.fetchMessageHabeas({
          idForm: this.formType.id,
          body: this.data_form,
        })

          .then((response) => {
            console.log(this.data_form)
            this.cleanForm()
            this.onlyNit = true
            this.$refs.userDocument.$el.focus()
            this.dismissSecs = 3.5
            // Habeas Data alerts

            if (response.details == 'mensaje enviado') {
              this.showAlert(
                'Mensaje enviado correctamente al usuario',
                'success'
              )
            } else if (
              response.details == 'usuario registrado previamente' ||
              'usuario ya registrado en habeas data'
            ) {
              this.showAlert('Habeas Data fue completado', 'success')
            }
            // Captacion alerts
            if (response.details == 'usuario enviado') {
              this.showAlert('Usuario enviado a captación', 'success')
            }
          })
          .catch((error) => {
            // Habeas Data alerts
            if (error.response.status === 400 && error.response.data.celular) {
              this.onlyNit = false
              this.$nextTick(() => {
                this.$refs.userPhone.$el.focus()
              })
              this.dismissSecs = 1.5
              this.showAlert('Usuario sin habeas Data, continuar registro')
              return null
            }
            // Captacion alerts
            if (error.response.data.details == 'error interno - epik') {
              this.showAlert('No se pudo enviar usuario a captación', 'danger')
              return null
            }
            // Default alert
            this.$refs.userDocument.$el.focus()
            this.dismissSecs = 3.5
            this.showAlert('No se pudo enviar el mensaje', 'danger')
            return null
          })
      }
    },
    submitRejection() {
      this.rejection_form.nit = this.data_form.nit.trim()
      this.correct_nit = this.validateDocument(this.data_form.nit)
      this.rejection_form.selectedRejection = this.selectedRejection
      if (!this.correct_nit) {
        return null
      }

      // Envia el formulario de rechazo
      if (this.selectedRejection !== null) {
        this.formType.id = 4 // Cambiar formType.id a 4 cuando se selecciona una opción de rechazo
        // Aquí puedes realizar las acciones adicionales que necesites con el selectedRejection
        // Puedes enviarlo como una variable o realizar cualquier otra lógica basada en su valor
      }
      this.modalShow = false
      return this.fetchMessageHabeas({
        idForm: this.formType.id,
        body: this.rejection_form,
      })
        .then((response) => {
          this.cleanForm()
          this.onlyNit = true
          this.$refs.userDocument.$el.focus()
          this.dismissSecs = 3.5
          // Habeas Data alerts
          if (response.details == 'mensaje enviado') {
            this.showAlert(
              'Mensaje enviado correctamente al usuario',
              'success'
            )
          } else if (
            response.details == 'usuario registrado previamente' ||
            'Usuario Rejected'
          ) {
            this.showAlert('Habeas Data fue completado', 'success')
          }
          // Captacion alerts
          if (response.details == 'usuario enviado') {
            this.showAlert('Usuario enviado a captación', 'success')
          }
        })
        .catch((error) => {
          if (error.response.data.details == 'error interno - epik') {
            this.showAlert('No se pudo enviar usuario a captación', 'danger')
            return null
          }
        })
    },

    validateDocument(document) {
      const regex = /^[0-9]*$/
      if (!document) {
        this.message_nit = 'Número de documento no válido'
      } else if (!regex.test(document)) {
        this.message_nit = 'El número del documento no debe tener letras'
      } else if (document.length < 6 || document.length > 11) {
        this.message_nit = 'El documento debe tener mínimo entre 6 y 11 dígitos'
      } else {
        this.message_nit = ''
      }
      return !this.message_nit ? true : false
    },
    validateCellphone(cellphone) {
      const regex = /^[0-9]*$/
      if (!cellphone) {
        this.message_cel = 'Número de celular no válido'
      } else if (!regex.test(cellphone)) {
        this.message_cel = 'El número de celular no debe tener letras'
      } else if (cellphone.length !== 10) {
        this.message_cel = 'El celular debe tener 10 digitos'
      } else {
        this.message_cel = ''
      }
      return !this.message_cel ? true : false
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
      // if(this.dismissCountDown == 0)
      //   this.$refs.userDocument.$el.focus()
    },
    /**
     * Open a temporary alert box
     * @param {String} textAlert Alert content_type
     * @param {String} typeAlert Alert type: success, warning, danger
     */
    showAlert(textAlert = '', typeAlert = 'warning') {
      this.typeAlert = typeAlert
      this.textAlert = textAlert
      this.dismissCountDown = this.dismissSecs
    },
    cleanForm() {
      document.getElementById('forms_habeas').reset()
      this.rejection_form.selectedRejection = null
    },

    openModal() {
      this.selectedRejection = null
      this.rejection_form.nit = this.data_form.nit.trim()
      this.correct_nit = this.validateDocument(this.data_form.nit)
      if (this.onlyNit) {
        this.data_form.celular = ''
      } else {
        this.data_form.celular.trim()
        if (this.data_form.celular !== '') {
          this.correct_cel = this.validateCellphone(this.data_form.celular)
          if (!this.correct_cel) {
            return null
          }
        }
      }
      // Copy nit to clipboard
      navigator.clipboard.writeText(this.data_form.nit)
      if (!this.correct_nit) {
        return null
      }
      return this.fetchMessageHabeas({
        idForm: 3,
        body: this.rejection_form,
      })
        .then((response) => {
          if (
            response.details == 'usuario registrado previamente' ||
            'Usuario Rejected'
          ) {
            this.cleanForm()
            this.showAlert('Habeas Data fue completado', 'success')
          }
        })
        .catch((error) => {
          this.modalShow = true
          if (error.response.data.details == 'error interno - epik') {
            this.showAlert('No se pudo enviar usuario a captación', 'danger')
            return null
          }
        })
    },

    // Otros métodos y lógica del componente Vue

    // displayForm(formInfo){
    //   this.cajasIsOpen = false;
    //   this.onlyNit = true;
    //   // Form type data
    //   this.formType.id = formInfo.idForm;
    //   this.formType.form = formInfo.form;
    //   // Complete data to send
    //   this.data_form.cashRegister = formInfo.cashRegister;
    //   this.data_form.store = formInfo.store;
    //   this.data_form.storeCity = formInfo.storeCity;
    //   this.data_form.storeDepartment = formInfo.storeDepartment;
    // },

    // Cajas POS

    // ...captacionMethods,
    // getCashRegisters() {

    //   return this.fetchCashRegisterList()
    //     .then((response) => {
    //       // this.stores = response.data;
    //       this.setStores(response.data)
    //       console.log('Stores query completed')
    //     })
    //     .catch((error) => {
    //       console.log(error)
    //     })
    // },
  },
}
</script>

<template>
  <!-- default class like logging -->
  <!-- <Layout> -->
  <!-- Uncomment to captacion -->
  <!-- <CajasPos 
      v-model="cajasIsOpen"
      v-on:accept="displayForm"
      v-on:hidden="cajasIsOpen=false"
    >    
    </CajasPos> -->

  <!-- <div class="mb-3">
          <b-button-group class="w-100">
            <b-button
              type="submit"
              variant="light"
              class="w-100 waves-effect mx-1 text-primary font-weight-bold"
            >
              <span> Habeas Data </span>
            </b-button>
            <b-button
              v-on:click="cajasIsOpen=true"
              type="submit"
              variant="light"
              class="w-100 waves-effect mx-1 text-primary font-weight-bold"
            >
              <span> Captación </span>
            </b-button>
            <b-button
              v-b-toggle.caja-pos-1
              type="submit"
              variant="light"
              class="w-100 waves-effect mx-1 text-primary font-weight-bold"
            >
              <span> Todo </span>
            </b-button>
          </b-button-group>
        </div> -->
  <!-- <p class="h5 text-white font-weight-bold">{{ formType.form }} {{alertForm}}</p> -->

  <b-container
    style="width:100%; height:100%"
    class="d-flex justify-content-center align-items-center"
  >
    <div class="col-md-12 col-lg-10 col-xl-10">
      <div class="card shadow mt-2">
        <div class="card-body p-3 pb-0">
          <b-alert
            :show="dismissCountDown"
            variant="light"
            class="border mr-2 text-center w-75 mt-5 shadow"
            :class="'border-' + typeAlert"
            style="
                position: absolute;
                z-index: 1;
                left: 50%;
                transform: translateX(-50%);
              "
            @dismissed="dismissCountDown = 0"
            @dismiss-count-down="countDownChanged"
          >
            <div class="mt-2">
              <b-icon
                v-if="typeAlert == 'success'"
                icon="check-circle-fill"
                variant="success"
                style="width: 120px; height: 120px"
              >
              </b-icon>
              <b-icon
                v-if="typeAlert != 'success'"
                icon="exclamation-circle-fill"
                :variant="typeAlert"
                style="width: 120px; height: 120px"
              >
              </b-icon>
              <p class="h5 font-weight-bold" style="color: gray">{{
                textAlert
              }}</p>
            </div>
          </b-alert>
          <b-form id="forms_habeas" @submit.prevent="enviarForm">
            <!-- {{data_form}} -->
            <b-row class="justify-content-center">
              <!-- <b-col>
                  <b-form-group>
                    <label class="typo__label"
                      >Seleccionar centro operativo</label
                    >
                    <div class="text-center" v-if="!stores.length">
                      <b-spinner variant="primary" label="Spinning"></b-spinner>
                    </div>
                    <div v-if="stores.length">
                      <multiselect
                        :value="store"
                        v-on:select="
                          () => {
                            setCashRegister(null)
                          }
                        "
                        @input="setStore"
                        :options="stores"
                        :close-on-select="true"
                        :clear-on-select="true"
                        :preserve-search="true"
                        placeholder="Centro Operativo"
                        label="store_name"
                        track-by="store_code"
                        :allowEmpty="false"
                        :showLabels="false"
                      >
                      </multiselect>
                      <span v-if="!store" style="color: red">
                        *Seleccione un valor de la lista
                      </span>
                    </div>
                  </b-form-group>
                  <b-form-group>
                    <div v-if="store">
                      <label class="typo__label">Seleccionar caja</label>
                      <multiselect
                        :value="cashRegister"
                        :options="store.cash_register"
                        @input="setCashRegister"
                        :close-on-select="true"
                        :clear-on-select="true"
                        :preserve-search="true"
                        placeholder="Numero de caja"
                        label="id"
                        track-by="id"
                        :allowEmpty="false"
                        :showLabels="false"
                      >
                      </multiselect>
                      <span v-if="!cashRegister" style="color: red">
                        *Seleccione un valor de la lista
                      </span>
                    </div>
                  </b-form-group>
                </b-col> -->
              <b-col cols="10">
                <!-- <b-alert
                    :show="!alertForm"
                    variant="light"
                    class="border mr-3 text-center w-100 h-100 shadow d-flex align-content-center"
                    :class="'border-' + 'info'"
                    style="
                      position: absolute;
                      z-index: 1;
                      left: 50%;
                      transform: translateX(-50%);
                    "
                    @dismissed="dismissCountDown = 0"
                    @dismiss-count-down="countDownChanged"
                  >
                  <b-row align-v="center">
                    <b-col cols="2"
                     style="
                      position: absolute;
                      z-index: 1;
                      left: 10%;
                      transform: translateX(-50%);
                    ">
                                            <b-icon

                        icon="arrow-left-short"
                        :variant="'info'"
                        style="width: 50px; height:50px"
                        animation="cylon"
                      >
                      </b-icon>
                    </b-col>
                    <b-col>
                      <b-icon

                        icon="exclamation-circle-fill"
                        :variant="'info'"
                        style="width: 70px; height: 70px"
                      >
                      </b-icon>
                      <p class="h5 font-weight-bold mt-3" style="color: gray">
                       Diligencie todos los campos para continuar.
                      </p>
                    </b-col>
                  </b-row>
                  </b-alert> -->
                <b-form-group
                  id="input-group-1"
                  :label="'Tipo de documento'"
                  label-class="typo__label"
                  label-for="input-1"
                >
                  <b-form-select
                    v-model="data_form.tipo_docto"
                    class="border border-primary"
                    :options="options"
                  ></b-form-select>
                </b-form-group>
                <!-- end options -->

                <b-form-group
                  id="input-group-1"
                  :label="'Número del documento'"
                  label-class="typo__label"
                  label-for="input-1"
                >
                  <b-form-input
                    id="input-1"
                    v-model="data_form.nit"
                    ref="userDocument"
                    type="text"
                    required
                    placeholder="Ingrese el documento"
                    class="border border-primary"
                    autocomplete="off"
                    autofocus
                  ></b-form-input>
                  <span v-if="!correct_nit" style="color: red">
                    {{ message_nit }}
                  </span>
                </b-form-group>
                <!-- end nit message -->
                <b-form-group
                  v-if="!onlyNit"
                  id="input-group-1"
                  :label="'Número del celular'"
                  label-for="input-1"
                >
                  <b-form-input
                    id="input-1"
                    v-model="data_form.celular"
                    ref="userPhone"
                    type="text"
                    placeholder="Ingrese el número del celular"
                    autocomplete="off"
                  ></b-form-input>
                  <span v-if="!correct_cel" style="color: red">
                    {{ message_cel }}</span
                  >
                </b-form-group>
                <!-- end cel message -->

                <b-form-group id="button-group" class="mt-4 mb-0">
                  <b-button
                    type="submit"
                    variant="primary"
                    class="btn-block waves-effect"
                  >
                    <span> Enviar </span>
                  </b-button>

                  <!-- end enviar boton -->

                  <b-button
                    type="button"
                    variant="primary"
                    class="btn-block waves-effect"
                    @click="openModal"
                    v-model="rejectHabeas"
                    :value="false"
                  >
                    <span>Rechazar</span>
                  </b-button>

                  <b-modal
                    v-model="modalShow"
                    :title="rejectionTitle"
                    ok-only
                    hide-footer
                  >
                    <b-container class="p-0">
                      <b-col class="mx-auto" md="12">
                        <b-form-group>
                          <b-form-radio v-model="selectedRejection" :value="1"
                            >No tengo tiempo</b-form-radio
                          >
                          <b-form-radio v-model="selectedRejection" :value="2"
                            >No me gusta recibir información
                            publicitaria</b-form-radio
                          >
                          <b-form-radio v-model="selectedRejection" :value="3"
                            >Porque no se da incentivo</b-form-radio
                          >
                        </b-form-group>
                        <b-button
                          type="submit"
                          variant="primary"
                          @click="submitRejection"
                          v-model="rejectHabeas"
                          :value="true"
                          v-if="selectedRejection != null"
                          >Finalizar</b-button
                        >
                      </b-col>
                    </b-container>
                  </b-modal>
                </b-form-group>
              </b-col>
            </b-row>
            <!-- <b-form-group>
                <label class="typo__label">Seleccionar tipo de formulario</label>
                <multiselect 
                  v-model="formOption" 
                  v-on:select="store=null, cashRegister=null"
                  :options="formOptions" 
                  :close-on-select="true" 
                  :clear-on-select="true" 
                  :preserve-search="true" 
                  placeholder="Tipo de formulario" 
                  :allowEmpty="false"
                  label="name" 
                  track-by="id" 
                  :preselectFirst="true"
                  :showLabels="false"
                  @select="verifyFormOption"
                >
                </multiselect>
                <span v-if="!formOption" style="color: red">
                  *Seleccione un valor de la lista
                </span>
              </b-form-group> -->
            <!-- <pre>
                {{data_form}}
              </pre>

              <pre>
                {{store}}
              </pre> -->
          </b-form>
        </div>
        <!-- end card-body -->
      </div>
      <!-- end card -->
    </div>
    <!-- end col -->
  </b-container>
  <!-- end row -->
  <!-- </Layout> -->
</template>
<style lang="scss">
#forms_habeas {
  .custom-select,
  .form-control {
    font-size: 20px !important;
  }
}
</style>
